
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AppProductReviewInfoSection',
  props: {
    review: {
      type: Object,
      required: true
    },
    cols: {
      type: Number,
      required: true
    },
    productImageSize: {
      type: Number,
      default: 32
    },
    productThumbnailType: {
      type: String,
      default: 'circle'
    }
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapGetters('widget', ['thumbnailShape'])
  }
};
